export default __webpack_public_path__ + "static/media/banner-color-common.37a76e94.png";